exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--xyw-1Cqk6B97N3nr9PQ_4 tbody tr td {\n  border: none;\n  padding: 5px 0;\n}\n\n.PatientConsentForMedicalRecordsExchange--xyw-1Cqk6B97N3nr9PQ_4 {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.PatientConsentForMedicalRecordsExchange--xyw-1Cqk6B97N3nr9PQ_4 tbody tr th {\n  font-weight: bold;\n  padding: 5px 0;\n  width: 17%;\n}\n", ""]);

// exports
exports.locals = {
	"patientConsentTable": "PatientConsentForMedicalRecordsExchange--xyw-1Cqk6B97N3nr9PQ_4",
	"patientConsentTable": "PatientConsentForMedicalRecordsExchange--xyw-1Cqk6B97N3nr9PQ_4"
};